export default __webpack_public_path__ + "static/media/info-bold.43fd4d6e.svg";